export default "__VITE_ASSET__dn0ElzIU__"